import store from "../../store";
import { planningDestination } from "./access.mjs";

export default [{
    path: "/pianificazione",
    name: "pianificazione",
    meta: { menu: "pianificazione", title: "Pianificazione" },
    redirect(to) {
        const query = { ...to.query };
        if (query.vista === "fasi") query.vista = "gruppi";
        return { name: "pianificazione-lab", query, hash: to.hash };
    },
}, {
    path: "/av/aderenza/",
    redirect: to => ({ name: "pianificazione", query: to.query, hash: to.hash }),
}, {
    path: "/pianificazione-lab",
    name: "pianificazione-lab",
    meta: { menu: "pianificazione", title: "Pianificazione" },
    component: () => import("./lab/PlanningLab.vue"),
    beforeEnter(to, from, next) {
        const destination = planningDestination(store.getters.isLoggedIn, store.getters.userdata);
        if (destination) next(destination);
        else next();
    },
}];
